import common from "./common";
import {createStore} from "vuex";

const store = createStore(common);

export default store;
